const ru = {
  translation: {
    nav: {
      brand: 'IELTS Speaking AI',
      dashboard: 'Главная',
      logout: 'Выйти',
      admin: 'Админ',
    },
    auth: {
      login: 'Войти',
      register: 'Регистрация',
      email: 'Email',
      password: 'Пароль',
      name: 'Имя',
      forgotPassword: 'Забыли пароль?',
      noAccount: 'Нет аккаунта?',
      hasAccount: 'Есть аккаунт?',
      verifyTitle: 'Подтверждение email',
      verifyDesc: 'отправлен 6-значный код',
      codePlaceholder: '123456',
      confirm: 'Подтвердить',
      resendCode: 'Отправить код повторно',
      resetTitle: 'Восстановление пароля',
      resetDesc: 'Введите email, отправим код',
      newPassword: 'Новый пароль',
      updatePassword: 'Обновить пароль',
      sendCode: 'Отправить код',
      back: '← Назад',
      backToLogin: '← Вернуться к входу',
      loggingIn: 'Вход...',
      registering: 'Регистрация...',
      sending: 'Отправка...',
      checking: 'Проверка...',
      saving: 'Сохранение...',
      continue: 'Продолжить',
    },
    dashboard: {
      welcome: 'Добро пожаловать',
      subtitle: 'Продолжайте подготовку к IELTS Speaking.',
      level: 'Уровень',
      totalXp: 'Всего XP',
      streak: 'Серия дней',
      longestStreak: 'Рекорд',
      avgScore: 'Средний балл',
      sessions: 'сессий',
      dailyLimit: 'Дневной лимит',
      resetsAt: 'Обновляется каждый день в 00:00',
      remaining: 'осталось',
      used: 'использовано',
      limitDone: 'Исчерпан',
      startBtn: 'Начать →',
      vocabTitle: 'Topic Vocabulary',
      vocabDesc: 'Введите тему и получите словарь для IELTS Speaking.',
      speakingTitle: 'Speaking Practice',
      speakingDesc: 'Выберите Part 1, 2 или 3. Практикуйтесь с AI.',
      leaderboard: 'Рейтинг',
      today: 'Сегодня',
      week: 'Неделя',
      noLeaderboard: 'Пока никто не практиковался',
      recentSessions: 'Последние сессии',
      noSessions: 'Сессий ещё нет. Начните первую!',
      tabHome: '🏠 Главная',
      tabProgress: '📈 Прогресс',
      tabExam: '🎓 Mock Exam',
      youLabel: 'вы',
      premiumUnlimited: 'Premium — Безлимитный доступ',
      premiumExpires: 'Premium истекает',
      daysLeft: 'дней осталось',
    },
    speaking: {
      title: 'Speaking Practice',
      subtitle: 'Какой раздел хотите практиковать?',
      selectTopic: 'Выберите тему',
      completed: 'пройдено',
      sessionTitle: 'Speaking Session',
      questions: 'вопросов',
      startBtn: '🚀 Начать практику',
      stopBtn: '⏹ Завершить',
      nextBtn: '➡️ Следующий вопрос',
      finishBtn: '✅ Завершить сессию',
      retryBtn: '🔄 Ответить заново',
      repeatBtn: 'Повторить вопрос',
      speakBtn: '🎤 Говорить',
      stopListenBtn: '⏹ Остановить и получить отзыв',
      listening: 'Слушаю... Говорите!',
      pressToSpeak: 'Нажмите кнопку микрофона и говорите',
      aiAnalyzing: 'AI анализирует ваш ответ...',
      yourAnswer: 'Ваш ответ',
      aiExaminer: 'AI Экзаменатор',
      speaking: '🔊 Говорит...',
      feedbackTitle: '📝 Отзыв AI',
      score: 'Балл',
      improvedVersion: '✨ Улучшенная версия (Band 7-8)',
      sessionEnded: '🏆 Сессия завершена!',
      answeredAll: 'вопросов отвечено. Отлично!',
      chooseTopic: 'Выбрать другую тему',
      sessionResults: '📋 Результаты сессии',
      previousQuestions: '📋 Предыдущие вопросы',
      part2prep: '📝 Время подготовки',
      part2speak: '🎤 Время речи',
      part2prepNote: 'Делайте заметки. Таймер начнётся автоматически.',
      part2info: 'Part 2 — Режим таймера',
      part2min1: '1 минута подготовки',
      part2min2: '2 минуты для речи',
      part2auto: 'Таймер переключается автоматически',
      preparation: 'Подготовка',
      chromeTip: 'Используйте Chrome или Edge',
      micTip: 'Разрешите доступ к микрофону',
      quietTip: 'Находитесь в тихом месте',
      questionList: 'Вопросы',
      back: '← Назад',
      savedSession: 'Сессия сохранена!',
      avgScoreLabel: 'Средний балл',
      xpEarned: 'XP заработано',
      streakLabel: 'Серия дней',
      continueBtn: 'Продолжить',
      fluency: 'Беглость',
      vocabulary: 'Словарный запас',
      grammar: 'Грамматика',
      pronunciation: 'Произношение',
      yourAnswerLabel: 'Ваш ответ',
      improvedLabel: 'Улучшено',
    },
    mockExam: {
  title: '🎓 Mock IELTS Speaking',
  subtitle: 'Полная симуляция экзамена — случайные темы',
  startBtn: '🚀 Начать экзамен',
  preparing: 'Готовим вопросы...',
  randomNote: '🎲 Каждый раз выбираются случайные темы — как на реальном экзамене',
  weeklyLimit: 'Недельный лимит исчерпан',
  getPremium: '👑 Смотреть Premium',
  partBreak: 'завершена!',
  starting: 'начинается...',
  topic: 'Тема',
  cancelBtn: '⏹ Завершить экзамен',
  cancelConfirm: 'Хотите завершить экзамен? Результат не сохранится.',
  resultTitle: 'Экзамен завершён!',
  bandScore: 'Ваш IELTS Band Score:',
  retake: '🔄 Пересдать',
  toDashboard: 'На главную →',
  analyzeMsg: 'AI анализирует...',
  retry: '🔄 Ещё раз',
  next: '➡️ Следующий вопрос',
  finishPart: 'перейти к Part',
  finishExam: '🏁 Завершить экзамен',
  history: 'Предыдущие экзамены',
  noHistory: 'Экзаменов ещё нет. Начните первый!',
  xpEarned: 'XP заработано',
},
progress: {
  title: 'Еженедельный прогресс',
  goalTitle: '🎯 Целевой Band Score',
  change: 'Изменить',
  cancel: 'Отмена',
  highGoal: '🌟 Высокая цель! Нужно много практики',
  realisticGoal: '✅ Реалистичная цель!',
  startGoal: 'Начальная цель, можно повысить позже',
  currentScore: 'Текущий балл',
  goalReached: '✅ Цель достигнута!',
  remaining: 'осталось',
  consistency: 'Регулярность',
  weeklySessions: 'Сессий в неделю',
  forecast: '🔮 Прогноз',
  forecastNote: 'Realistic = текущий темп · Optimal = ежедневная практика',
  goalTarget: 'Цель',
  realistic: 'Realistic',
  optimal: 'Optimal',
  goalReachedLabel: '🎯 Цель!',
  tip: '💡 Совет',
  lastSession: 'Последняя практика',
  daysAgo: 'дней назад',
  totalSessions: 'сессий проанализировано',
  needMore: 'Для графика нужно минимум 3 сессии.',
  goalSaved: 'Цель сохранена выше.',
  targetLine: 'Цель',
},
premium: {
  title: 'Premium',
  subtitle: 'Практикуйтесь без ограничений',
  activeTitle: 'Вы Premium пользователь!',
  daysLeft: 'дней осталось',
  allOpen: 'Все функции открыты ✓',
  backDashboard: 'На главную',
  feature: 'Функция',
  free: 'Бесплатно',
  popular: 'Популярный',
  selectedPlan: 'Выбранный тариф',
  howToPay: 'Как оплатить:',
  step1: '1. Нажмите кнопку Telegram',
  step2: '2. Укажите тариф и ваш ID',
  step3: '3. Произведите оплату',
  step4: '4. Админ активирует Premium в течение 24ч',
  yourId: 'Ваш User ID (отправьте администратору):',
  copy: 'Копировать',
  copied: '✓',
  telegramBtn: 'Написать в Telegram',
  note: 'Доступ открывается в течение 24 часов после оплаты',
  back: '← Назад',
  sum: 'сум',
},
    vocab: {
      title: '📚 Topic Vocabulary',
      placeholder: 'Введите тему... (например: Technology, Education)',
      searchBtn: '🔍 Найти',
      searching: '⏳ Поиск...',
      resultsFor: 'слова по теме',
      definition: 'Определение',
      example: 'Пример',
      error: 'Ошибка при получении словаря. Попробуйте снова.',
      limitError: 'Дневной лимит исчерпан! 7 запросов в день. Попробуйте завтра.',
    },
    common: {
      loading: 'Загрузка...',
      back: '← Назад',
      question: 'Вопрос',
      answer: 'Ответ',
    },
  },
};
export default ru;